export const DCSPGlobalComissioningBidAmazonBidUpload: string[] = [
  'Nº',
  'Short Description',
  'Qty',
  'Unit of Measure',
  'Commodity Id',
  'Sourcing Event Item (DTRM ID)',
  'bidding event',
  'Reference Price',
  'Item type',
  'Target Price',
  'Maximum Allowed Price',
  'Initial Item ID',
  'Sourcing Item Group',
  'Deactivated'
];

export const DCSPGlobalComissioningBidSupplierBidUpload: string[] = [
  'Nº',
  'Short Description',
  'Qty',
  'Unit of Measure',
  'Proposed unit Price',
  'Total rebate',
  'Commodity Id',
  'Description',
  'Details',
  'Net Total',
  'Total Amount (USD)',
  'Sourcing Item Group'
];

export const DCSPGlobalComissioningBidTemplateHeaders: Map<string, string[]> = new Map([
    ['Amazon Bid Upload', DCSPGlobalComissioningBidAmazonBidUpload],
    ['Supplier Bid Upload', DCSPGlobalComissioningBidSupplierBidUpload]
])